/* HH free-gift guard (Cowork, hardened 7 Sep 2026 after order #HHO2859).
   The two bonus packs are real $0 published variants (the packer needs a
   pickable SKU line), so they can be added on their own, or left behind after
   the Grip-X line is removed, giving somebody a free box. This runs on every
   page (the cart drawer renders site-wide, including /cart) and:
     1) strips any bonus-pack line that has not been earned;
     2) on a bonus-pack PRODUCT page, disables the add-to-cart + dynamic-checkout
        buttons (belt and braces in case templates/product.gift.json is not
        applied to the product yet);
     3) shows a brief friendly note when it corrects the cart.
   Entitlement: 10+ Grip-X boxes -> 1x X2235BK pack; 20+ -> also 1x X2235.
   Client-side defence-in-depth only; the true lock is the server-side guard. */
(function () {
  if (window.__hhGiftGuard) return;
  window.__hhGiftGuard = true;

  var GRIPX = ['heavy-duty-black-nitrile-gloves-50-pack', 'test-do-not-publish-grip-x-black-subscription-build'];
  var GIFTS = {
    'free-gift-se-premium-black-nitrile-gloves-x2235bk': 10,
    'free-gift-se-premium-blue-nitrile-gloves-x2235': 20
  };

  /* Fly and Appstle patch window.fetch; use a clean one so our writes are not reprocessed */
  var nf = (function () {
    try {
      var f = document.createElement('iframe');
      f.style.display = 'none';
      (document.body || document.documentElement).appendChild(f);
      var ff = f.contentWindow && f.contentWindow.fetch;
      if (ff) return ff.bind(f.contentWindow);
    } catch (e) {}
    return window.fetch.bind(window);
  })();
  var ORIGIN = window.location.origin;
  var busy = false;

  function sections() {
    var cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.getSectionsToRender === 'function') {
      return cd.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function notify(msg) {
    try {
      var el = document.getElementById('hh-gift-toast');
      if (!el) {
        el = document.createElement('div');
        el.id = 'hh-gift-toast';
        el.setAttribute('role', 'status');
        el.style.cssText = 'position:fixed;left:50%;bottom:22px;transform:translateX(-50%);z-index:100000;max-width:90vw;background:#172a5e;color:#fff;font:600 13px/1.35 var(--font-body-family,sans-serif);padding:11px 16px;border-radius:10px;box-shadow:0 10px 30px -8px rgba(0,0,0,.45);opacity:0;transition:opacity .25s ease;pointer-events:none;text-align:center;';
        (document.body || document.documentElement).appendChild(el);
      }
      el.textContent = msg;
      requestAnimationFrame(function () { el.style.opacity = '1'; });
      clearTimeout(el.__hideT);
      el.__hideT = setTimeout(function () { el.style.opacity = '0'; }, 4200);
    } catch (e) {}
  }

  function check() {
    if (busy) return;
    busy = true;
    nf(ORIGIN + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var gx = 0;
        items.forEach(function (i) { if (GRIPX.indexOf(i.handle) > -1) gx += i.quantity; });

        var fixes = [];
        items.forEach(function (i) {
          var min = GIFTS[i.handle];
          if (min === undefined) return;
          var allowed = gx >= min ? 1 : 0;
          if (i.quantity !== allowed) fixes.push({ key: i.key, quantity: allowed });
        });
        if (!fixes.length) { busy = false; return; }

        var run = fixes.reduce(function (chain, f) {
          return chain.then(function () {
            return nf(ORIGIN + '/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
              body: JSON.stringify({ id: f.key, quantity: f.quantity, sections: sections(), sections_url: window.location.pathname })
            }).then(function (r) { return r.json(); });
          });
        }, Promise.resolve());

        run.then(function (data) {
          var cd = document.querySelector('cart-drawer');
          if (cd && typeof cd.renderContents === 'function' && data && data.sections) {
            cd.renderContents(data);
          } else if (/^\/cart/.test(window.location.pathname)) {
            window.location.reload();
          }
          notify('Bonus packs are free with 10+ boxes of Grip-X. Cart updated.');
          busy = false;
        }).catch(function () { busy = false; });
      })
      .catch(function () { busy = false; });
  }

  /* Task 4: on a bonus-pack product page, kill the buy path (button + dynamic checkout). */
  function neutraliseGiftPage() {
    if (!/\/products\/free-gift-/.test(window.location.pathname)) return;
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    Array.prototype.forEach.call(forms, function (f) {
      f.addEventListener('submit', function (e) { e.preventDefault(); e.stopPropagation(); }, true);
      var btn = f.querySelector('[name="add"], .product-form__submit, button[type="submit"]');
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        var lbl = btn.querySelector('span') || btn;
        lbl.textContent = 'Free with 10+ Grip-X boxes';
      }
      var pay = f.querySelector('.shopify-payment-button, shopify-payment-button');
      if (pay) pay.style.display = 'none';
    });
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(check, 400); }

  function boot() {
    neutraliseGiftPage();
    check();
    var cd = document.querySelector('cart-drawer');
    if (cd && window.MutationObserver) {
      new MutationObserver(schedule).observe(cd, { childList: true, subtree: true });
    }
    var form = document.getElementById('CartDrawer-Form') || document.querySelector('form[action$="/cart"]');
    if (form) form.addEventListener('change', schedule);
    document.addEventListener('click', function (e) {
      if (e.target.closest('cart-remove-button, .quantity__button, .cart-remove-button')) schedule();
    }, true);
    ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (ev) {
      document.addEventListener(ev, schedule);
      window.addEventListener(ev, schedule);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
